import React from "react";
import { Button } from "../../ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../ui/alert-dialog";
import { Dialog, DialogContent, DialogTrigger } from "../../ui/dialog";
import CrearEditarTimeValue from "./CrearEditarTimeValue.jsx";
import { TrashIcon } from "@radix-ui/react-icons";
import { Pencil1Icon } from "@radix-ui/react-icons";
import { deleteTimeValue } from "../../../provider/adm/profesores/BankData/TimeValue/deleteTimeValue";

const TimeValueCRUD = ({
  timeValues,
  selectedTimeValueId,
  setSelectedTimeValueId,
  selectedTimeValueName,
  setSelectedTimeValueName,
  setLoading,
  fetchTimeValues,
}) => {
  const handleDeleteTimeValue = async () => {
    setLoading(true);
    try {
      await deleteTimeValue(selectedTimeValueId);
      fetchTimeValues(); // Refresh the time values after deletion
    } catch (error) {
      console.error("Error deleting time value:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form className="space-y-4 mb-6 w-[100%]">
        <h3 className="text-lg font-semibold">Seleccionar Nómina</h3>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre de la nómina
          </label>
          <div className="grid grid-cols-[1fr_auto_auto] items-center gap-4">
            <Select
              value={selectedTimeValueName}
              onValueChange={(value) => {
                const selectedTimeValue = timeValues.find(
                  (timeValue) => timeValue.name === value
                );
                if (selectedTimeValue) {
                  setSelectedTimeValueName(selectedTimeValue.name);
                  setSelectedTimeValueId(selectedTimeValue.id);
                }
              }}
            >
              <SelectTrigger className="w-[100%]">
                <SelectValue placeholder="Seleccionar nómina" />
              </SelectTrigger>
              <SelectContent>
                {timeValues.map((timeValue) => (
                  <SelectItem key={timeValue.id} value={timeValue.name}>
                    {timeValue.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <AlertDialog>
              <AlertDialogTrigger>
                <TrashIcon className="w-6 h-6 text-gray-400" />
              </AlertDialogTrigger>
              <AlertDialogContent>
                <AlertDialogHeader>
                  <AlertDialogTitle>
                    ¿Estás absolutamente seguro?
                  </AlertDialogTitle>
                  <AlertDialogDescription>
                    Esta acción no se puede deshacer. Esto eliminará
                    permanentemente la nómina y todos sus datos asociados.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel>Cancelar</AlertDialogCancel>
                  <AlertDialogAction onClick={handleDeleteTimeValue}>
                    Sí, eliminar
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
            <Dialog>
              <DialogTrigger asChild>
                <Pencil1Icon className="w-6 h-6 text-gray-400" />
              </DialogTrigger>
              <DialogContent className="sm:max-w-[425px]">
                <CrearEditarTimeValue
                    fetchTimeValues={fetchTimeValues} setLoading={setLoading}
                  data={
                    selectedTimeValueName
                      ? timeValues.find(tv => tv.name === selectedTimeValueName) || {}
                      : {}
                  }
                  context={selectedTimeValueName ? "editar" : "crear"}
                />
              </DialogContent>
            </Dialog>
          </div>
        </div>
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="ghost">Crear Nómina +</Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <CrearEditarTimeValue fetchTimeValues={fetchTimeValues} setLoading={setLoading} data={{}} context={"crear"} />
          </DialogContent>
        </Dialog>
      </form>
    </>
  );
};

export default TimeValueCRUD;